<template>
  <div
    v-waypoint="{
      active: true,
      callback: onWaypoint,
      options: intersectionOptions,
    }"
    style="
      border: 0;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
    "
  >
    <iframe
      ref="video"
      :src="src"
      loading="lazy"
      style="
        border: 0;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
      "
      allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
      allowfullscreen="true"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'VideoBunny',
  props: {
    src: {
      type: String,
      required: true,
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    inScreen: false,
    player: null,
    playerIsReady: false,
    actionToWait: null,
    intersectionOptions: {
      root: null,
      rootMargin: '0px 0px 0px 0px',
      threshold: [0, 1],
    },
  }),
  mounted() {
    if (!document.getElementById('bunny-player')) {
      const tag = document.createElement('script')
      tag.src = '//assets.mediadelivery.net/playerjs/player-0.1.0.min.js'
      tag.id = 'bunny-player'
      tag.async = true
      tag.onload = () => {
        this.initBunnyPlayer()
      }
      document.body.appendChild(tag)
    } else if (typeof playerjs === 'undefined') {
      this.waitForPlayer()
    } else {
      this.initBunnyPlayer()
    }
  },
  methods: {
    waitForPlayer() {
      const interval = setInterval(() => {
        if (typeof playerjs !== 'undefined') {
          clearInterval(interval)
          this.initBunnyPlayer()
        }
      }, 2000)
    },
    initBunnyPlayer() {
      if (typeof playerjs === 'undefined') {
        return
      }

      if (this.$refs.video) {
        this.player = new playerjs.Player(this.$refs.video)
      } else {
        return console.warn('no video ref')
      }

      this.player.on('ready', (_) => {
        if (this.actionWait) {
          this.player[this.actionWait]()
          this.actionWait = null
        }

        this.playerIsReady = true

        this.$emit('ready', this.player)
      })
    },
    onWaypoint(waypoint) {
      if (waypoint.going === this.$waypointMap.GOING_OUT && this.inScreen) {
        this.screenOut()
        this.inScreen = false
      }

      if (waypoint.going === this.$waypointMap.GOING_IN && !this.inScreen) {
        this.screenIn()
        this.inScreen = true
      }
    },
    screenIn() {
      if (this.playerIsReady) {
        if (this.autoplay) {
          this.player.play()

          setTimeout(() => {
            this.player.getPaused((paused) => {
              if (paused) {
                this.player.getMuted((muted) => {
                  if (!muted) {
                    this.player.mute()
                    this.player.play()
                  }
                })
              }
            })
          }, 300)
        }
      } else {
        this.actionWait = 'play'
      }
    },
    screenOut() {
      if (this.playerIsReady) {
        this.player.pause()
      } else {
        this.actionWait = 'pause'
      }
    },
  },
}
</script>
